if (document.querySelector('.transplantationstag-fragen')) {
    const press = document.querySelector('.transplantationstag-fragen').firstElementChild;

    document.addEventListener('click', ev => {
        if (!ev.target.parentNode.matches('.transplantationstag-open-modal')) {
            return;
        }

        press.click();
    })
}
